export function getAll() {
  return [
    {
      value: -1,
      name: "All",
      text: `全部`,
    },
    {
      value: 0,
      name: "Front",
      text: `前台`,
    },
    {
      value: 1,
      name: "UShowWeb",
      text: `線上點餐`,
    },
  ];
}
